'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = /*@ngInject*/scOptions;

function scOptions() {

  return {
    restrict: 'A',
    require: 'scSelect',
    link: function link(scope, elm, attrs, scSelectCtrl) {
      scSelectCtrl.setOptionScope(scope);
    }
  };
}

module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./src/directives/scOptions.js
 **/